import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { ProjectFile } from 'app/interfaces/project-file.model';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes } from 'ngx-uploader';
import * as _ from 'lodash';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-file-editor',
  templateUrl: './file-editor.component.html',
  styleUrls: ['./file-editor.component.scss'],
})
export class FileEditorComponent implements OnInit {
  @Input() files: Array<any>;
  @Input() contentId: number;
  @Input() type: string;

  phaseLookup = ['', 'Competition', 'Design', 'In progress', 'On site', 'Realized'];
  fileBlueprint: any = {
    Phase: 0,
    Category: '',
    UsedInWebsite: false,
    UsedInArchive: false,
    UsedInPressKit: false,
    UsedAsWebsiteMainImage: false,
    Caption: '',
    Caption_CN: '',
  };

  formData: FormData;
  filesToUpload: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;

  constructor() {
    this.filesToUpload = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() {}

  onUploadOutput(output: UploadOutput): void {
    //console.log(output); // lets output to see what's going on in the console

    if (output.type === 'allAddedToQueue') {
      // when all files added in queue
      // uncomment this if you want to auto upload files when added
      const event: UploadInput = {
        type: 'uploadAll',
        url: `${environment.apiUrl}files/upload?type=${this.type}&contentId=${this.contentId}`,
        method: 'POST',
      };
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue') {
      this.filesToUpload.push(output.file); // add file to array when added
      this.files.splice(0, 0, { Filename: output.file.name, Progress: output.file.progress.data.percentage });
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files
        .map(a => {
          return a.Filename;
        })
        .indexOf(output.file.name);
      this.files[index].Progress = output.file.progress.data.percentage;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.filesToUpload = this.filesToUpload.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      // drag over event
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      // drag out event
      this.dragOver = false;
    } else if (output.type === 'drop') {
      // on drop event
      this.dragOver = false;
    } else if (output.type === 'done') {
      // on drop event
      const index = this.files
        .map(a => {
          return a.Filename;
        })
        .indexOf(output.file.response.Filename);
      if (output.file.responseStatus !== 400 && output.file.responseStatus !== 500) {
        this.files[index] = output.file.response;
      } else {
        // remove the file from the list (it failed and has no id)
        this.files = this.files.filter(a => a.Id);
      }
    }
  }

  startUpload(): void {
    // manually start uploading
    const event: UploadInput = {
      type: 'uploadAll',
      url: '/upload',
      method: 'POST',
      data: { foo: 'bar' },
    };

    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  filesSelected(): Array<any> {
    return this.files.filter((a: any) => {
      return a.selected;
    });
  }

  deleteFile() {
    _.remove(this.files, a => this.filesSelected().indexOf(a) >= 0);
  }

  setFileProperties() {
    // Check if the main image is changed and reset all other images to not be the main image
    if (this.fileBlueprint.UsedAsWebsiteMainImage) {
      this.files.forEach(file => {
        file.UsedAsWebsiteMainImage = false;
      });
    }

    this.filesSelected().forEach(a => {
      a.Phase = this.fileBlueprint.Phase;
      a.Category = this.fileBlueprint.Category;
      a.UsedInWebsite = this.fileBlueprint.UsedInWebsite;
      a.UsedInArchive = this.fileBlueprint.UsedInArchive;
      a.UsedInPressKit = this.fileBlueprint.UsedInPressKit;
      a.UsedAsWebsiteMainImage = this.fileBlueprint.UsedAsWebsiteMainImage;
      a.Caption = this.fileBlueprint.Caption;
      a.Caption_CN = this.fileBlueprint.Caption_CN;
      a.selected = false;
    });

    this.fileBlueprint = {
      Phase: 0,
      Category: '',
      UsedInWebsite: false,
      UsedInArchive: false,
      UsedInPressKit: false,
      UsedAsWebsiteMainImage: false,
      Caption: '',
      Caption_CN: '',
    };
  }
}
